// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/AdditionalServicePrices_ListaPorFranquiaResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * ResponseContract de GET /so/additional_service_prices/lista_por_franquia/{id}
 * (controllers/so/additional_service_prices.php::lista_por_franquia).
 *
 * As linhas de UMA franquia, INCLUSIVE as inativas — "desligado" e um estado
 * que a gestao mostra para poder religar.
 */
import type { AdditionalServicePrices_PriceRow } from './AdditionalServicePrices_PriceRow'
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export type AdditionalServicePrices_ListaPorFranquiaResponseDados = AdditionalServicePrices_PriceRow[];

export type AdditionalServicePrices_ListaPorFranquiaResponse = ApiResponse<AdditionalServicePrices_ListaPorFranquiaResponseDados>;

registerResponseContract('AdditionalServicePrices_ListaPorFranquiaResponse', {
  _root: {
    type: 'array',
    required: true,
    items: {
      so_additional_service_price_id:            { type: 'number',  required: true },
      so_additional_service_price_additional_id: { type: 'number',  required: false },
      so_additional_service_price_franchise_id:  { type: 'number',  required: false },
      so_additional_service_price_price:         { type: 'number',  required: false },
      so_additional_service_price_deadline_days: { type: 'number',  required: false },
      so_additional_service_price_active:        { type: 'number',  required: false },
      so_additional_service_price_created_at:    { type: 'string',  required: false },
      so_additional_service_name:                { type: 'string',  required: false },
      so_additional_service_default_price:       { type: 'number',  required: false },
      so_service_category_name:                  { type: 'string',  required: false },
      franquia:                                  { type: 'string',  required: false },
    },
  },
})
